/*
 * @Author: v_smwang
 * @Date: 2020-07-29 16:20:30
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-21 11:24:40
 * @FilePath: \src\utils\request.js
 * @Description: 描述
 * @Module: 模块路径
 */
import Vue from 'vue';
import axios from 'axios';
import notification from 'ant-design-vue/es/notification';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import MapAccount from '@/libs/MapAccount';
import confirm from 'ant-design-vue/es/modal/confirm';

const BASE_URL = '';
// 创建 axios 实例
const service = axios.create({
  baseURL: BASE_URL, // api base_url
  timeout: 0, // 请求超时时间
});
const err = (error) => {
  if (error.response) {
    const { data } = error.response;
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message,
      });
    } else if (error.response.status === 401 || error.response.status === 101) {
      confirm({
        title: '提示',
        content: '登录已失效，请重新登录！',
        onOk: () => {
          MapAccount.login();
        },
      });
    } else if (error.response.status === 500) {
      notification.error({
        message: '服务器出错了...',
      });
    } else {
      notification.error({
        message: '服务端发生问题...',
        description: error.response.status,
      });
    }
  }
  return Promise.reject(error);
};

// request interceptor
service.interceptors.request.use((req) => {
  const token = Vue.ls.get(ACCESS_TOKEN);
  if (token) {
    req.headers['Access-Token'] = token; // 让每个请求携带自定义 token 请根据实际情况自行修改
    req.headers['Content-Type'] = 'application/json';
  }
  const ts = new Date().getTime();
  if (ts) { // 让每个请求携带时间戳，服务器会校准时间戳，30s内成功，失败的请校准系统时间
    req.headers.ts = ts;
  }
  return req;
}, err);

// response interceptor
service.interceptors.response.use((response) => {
  const dataResponse = response.data;
  /**
   * 请求超时，请校准系统时间，清理缓存并重试
   */
  if (dataResponse.status === -3 && isApplicationJson(response.headers['content-type'])) {
    notification.error({
      message: '时间错误',
      description: '请先校准电脑系统时间，清理缓存并重试',
    });
  }
  /**
   * 这里的返回值 error_no 应该替换为你跟服务端定义的接口返回格式
   */
  if ((dataResponse.data && dataResponse.data.status !== 200) && dataResponse.status !== 200 && isApplicationJson(response.headers['content-type'])) {
    notification.error({
      message: '错误',
      description: '接口返回错误',
    });
    console.log('接口返回错误:', JSON.stringify(dataResponse.msg));
  }
  if (response.headers['content-disposition']) {
    // const fileName = response.headers['content-disposition'].split(';')[1].split('=')[1].replace(/^"|"$/g, '')
    // dataResponse.fileName = decodeURI(escape(fileName))
    return response;
  }
  return dataResponse.data;
}, err);

// install to vue instance
const VueServiceInstall = {
  install(Vue, axiosInstance = service) {
    console.assert(axiosInstance, `arguments error: axiosInstance=${axiosInstance}`);
    Object.defineProperties(Vue.prototype, {
      $http: {
        get: function get() {
          return axiosInstance;
        },
      },
    });
  },
};

function isApplicationJson(contentType) {
  return /application\/json/.test(contentType);
}

const fetcher = ({ url, method, data, responseType }) => {
  data.t = new Date().getTime();
  if (method === 'get' || method === 'delete') {
    return service({ url, method, params: data, responseType });
  }
  return service({ url, method, data, responseType });
};
export {
  VueServiceInstall,
  service,
  fetcher,
  service as axios,
};

export default service;
